var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import axios from 'axios';
import { contentUpdateSchema, contentCreateSchema, } from '@ackreditering/viewModels';
import { YURL } from 'yurl';
const apiBaseUrl = new YURL(process.env.NEXT_PUBLIC_API_BASE_URL || '').pathname('api/content/');
export const getContentList = (filter, trackException) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    try {
        if (filter.key) {
            filter.key = decodeURIComponent(filter.key);
        }
        const options = {
            timeout: 10000,
            data: '',
            url: apiBaseUrl
                .clone()
                .query(filter)
                .format(),
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        };
        const response = yield axios(options);
        const { status, data } = response;
        if (data != null && status >= 200 && status < 300 && data.success) {
            return {
                success: true,
                data: data.data,
            };
        }
        else {
            return {
                success: false,
                statusCode: status,
                errorMessageCode: data.errorMessageCode,
                collision: data.collision,
            };
        }
    }
    catch (e) {
        trackException(new Error(`Failed to get content. ${e}`));
        if (axios.isAxiosError(e)) {
            const axiosError = e;
            console.log('Axios error. Code:', axiosError.code, ' Status:', axiosError.status);
            console.log('Axios error. Response Status:', (_a = axiosError.response) === null || _a === void 0 ? void 0 : _a.status, ' Data:', (_b = axiosError.response) === null || _b === void 0 ? void 0 : _b.data);
            return {
                success: false,
                statusCode: (_c = axiosError.response) === null || _c === void 0 ? void 0 : _c.status,
                errorMessageCode: (_f = (_e = (_d = axiosError.response) === null || _d === void 0 ? void 0 : _d.data) === null || _e === void 0 ? void 0 : _e.errorMessageCode) !== null && _f !== void 0 ? _f : 'error.fetch.failed',
                collision: (_j = (_h = (_g = axiosError.response) === null || _g === void 0 ? void 0 : _g.data) === null || _h === void 0 ? void 0 : _h.collision) !== null && _j !== void 0 ? _j : false,
            };
        }
        return {
            success: false,
            errorMessageCode: 'error.fetch.failed',
        };
    }
});
export const getContent = (id, trackException) => __awaiter(void 0, void 0, void 0, function* () {
    var _k, _l, _m, _o, _p, _q, _r, _s, _t;
    try {
        const options = {
            timeout: 10000,
            data: '',
            url: apiBaseUrl.clone().format(),
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        };
        const response = yield axios(options);
        const { status, data } = response;
        if (data != null && status >= 200 && status < 300 && data.success) {
            return {
                success: true,
                data: data.data,
            };
        }
        else {
            return {
                success: false,
                statusCode: status,
                errorMessageCode: data.errorMessageCode,
                collision: data.collision,
            };
        }
    }
    catch (e) {
        trackException(new Error(`Failed to get content. ${e}`));
        if (axios.isAxiosError(e)) {
            const axiosError = e;
            console.log('Axios error. Code:', axiosError.code, ' Status:', axiosError.status);
            console.log('Axios error. Response Status:', (_k = axiosError.response) === null || _k === void 0 ? void 0 : _k.status, ' Data:', (_l = axiosError.response) === null || _l === void 0 ? void 0 : _l.data);
            return {
                success: false,
                statusCode: (_m = axiosError.response) === null || _m === void 0 ? void 0 : _m.status,
                errorMessageCode: (_q = (_p = (_o = axiosError.response) === null || _o === void 0 ? void 0 : _o.data) === null || _p === void 0 ? void 0 : _p.errorMessageCode) !== null && _q !== void 0 ? _q : 'error.fetch.failed',
                collision: (_t = (_s = (_r = axiosError.response) === null || _r === void 0 ? void 0 : _r.data) === null || _s === void 0 ? void 0 : _s.collision) !== null && _t !== void 0 ? _t : false,
            };
        }
        return {
            success: false,
            errorMessageCode: 'error.fetch.failed',
        };
    }
});
export const deleteContent = (id, trackException) => __awaiter(void 0, void 0, void 0, function* () {
    var _u, _v, _w, _x, _y, _z, _0;
    try {
        const options = {
            timeout: 10000,
            data: '',
            url: apiBaseUrl.clone().pathname(`${id}`).format(),
            method: 'DELETE',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        };
        const response = yield axios(options);
        const { status, data } = response;
        if (data != null && status >= 200 && status < 300) {
            return {
                success: true,
            };
        }
        else {
            return {
                success: false,
                statusCode: status,
                errorMessageCode: (_u = data.errorMessageCode) !== null && _u !== void 0 ? _u : 'error.deletion.failed',
                notFound: data.notFound,
            };
        }
    }
    catch (e) {
        trackException(new Error(`Failed to delete content. ${e}`));
        if (axios.isAxiosError(e)) {
            const axiosError = e;
            console.log('Axios error. Code:', axiosError.code, ' Status:', axiosError.status);
            console.log('Axios error. Response Status:', (_v = axiosError.response) === null || _v === void 0 ? void 0 : _v.status, ' Data:', (_w = axiosError.response) === null || _w === void 0 ? void 0 : _w.data);
            return {
                success: false,
                statusCode: (_x = axiosError.response) === null || _x === void 0 ? void 0 : _x.status,
                errorMessageCode: (_0 = (_z = (_y = axiosError.response) === null || _y === void 0 ? void 0 : _y.data) === null || _z === void 0 ? void 0 : _z.errorMessageCode) !== null && _0 !== void 0 ? _0 : 'error.deletion.failed',
            };
        }
        return {
            success: false,
            errorMessageCode: 'error.deletion.failed',
        };
    }
});
export const createContent = (content, trackException) => __awaiter(void 0, void 0, void 0, function* () {
    var _1, _2, _3, _4, _5, _6, _7, _8, _9;
    if (!(yield contentCreateSchema.safeParseAsync(content)).success) {
        trackException(new Error('Data format error.'));
        return {
            success: false,
            errorMessageCode: 'error.data.format',
        };
    }
    try {
        const options = {
            timeout: 10000,
            data: content,
            url: apiBaseUrl.format(),
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        };
        console.log('Sending:', content);
        const response = yield axios(options);
        const { status, data } = response;
        if (data != null && status >= 200 && status < 300) {
            return {
                success: true,
            };
        }
        else {
            return {
                success: false,
                statusCode: status,
                errorMessageCode: data.errorMessageCode,
                notFound: data.notFound,
                collision: data.collision,
            };
        }
    }
    catch (e) {
        trackException(new Error(`Failed to create content. ${e}`));
        if (axios.isAxiosError(e)) {
            const axiosError = e;
            console.log('Axios error. Code:', axiosError.code, ' Status:', axiosError.status);
            console.log('Axios error. Response Status:', (_1 = axiosError.response) === null || _1 === void 0 ? void 0 : _1.status, ' Data:', (_2 = axiosError.response) === null || _2 === void 0 ? void 0 : _2.data);
            return {
                success: false,
                statusCode: (_3 = axiosError.response) === null || _3 === void 0 ? void 0 : _3.status,
                errorMessageCode: (_6 = (_5 = (_4 = axiosError.response) === null || _4 === void 0 ? void 0 : _4.data) === null || _5 === void 0 ? void 0 : _5.errorMessageCode) !== null && _6 !== void 0 ? _6 : 'error.create.failed',
                collision: (_9 = (_8 = (_7 = axiosError.response) === null || _7 === void 0 ? void 0 : _7.data) === null || _8 === void 0 ? void 0 : _8.collision) !== null && _9 !== void 0 ? _9 : false,
            };
        }
        return {
            success: false,
            errorMessageCode: 'error.create.failed',
        };
    }
});
export const updateContent = (content, trackException) => __awaiter(void 0, void 0, void 0, function* () {
    var _10, _11, _12, _13, _14, _15, _16, _17, _18;
    const contentValidation = yield contentUpdateSchema.safeParseAsync(content);
    if (!contentValidation.success) {
        console.log('Format error:', contentValidation.error);
        trackException(new Error('Data format error.'));
        return {
            success: false,
            errorMessageCode: 'error.data.format',
        };
    }
    const { id } = content, parameters = __rest(content, ["id"]);
    try {
        const options = {
            timeout: 10000,
            data: parameters,
            url: apiBaseUrl.clone().pathname(`${id}`).format(),
            method: 'PUT',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        };
        console.log('Sending:', parameters);
        const response = yield axios(options);
        const { status, data } = response;
        if (data != null && status >= 200 && status < 300) {
            return {
                success: true,
            };
        }
        else {
            return {
                success: false,
                statusCode: status,
                errorMessageCode: data.errorMessageCode,
                notFound: data.notFound,
                collision: data.collision,
            };
        }
    }
    catch (e) {
        trackException(new Error(`Failed to update content. ${e}`));
        if (axios.isAxiosError(e)) {
            const axiosError = e;
            console.log('Axios error. Code:', axiosError.code, ' Status:', axiosError.status);
            console.log('Axios error. Response Status:', (_10 = axiosError.response) === null || _10 === void 0 ? void 0 : _10.status, ' Data:', (_11 = axiosError.response) === null || _11 === void 0 ? void 0 : _11.data);
            return {
                success: false,
                statusCode: (_12 = axiosError.response) === null || _12 === void 0 ? void 0 : _12.status,
                errorMessageCode: (_15 = (_14 = (_13 = axiosError.response) === null || _13 === void 0 ? void 0 : _13.data) === null || _14 === void 0 ? void 0 : _14.errorMessageCode) !== null && _15 !== void 0 ? _15 : 'error.update.failed',
                collision: (_18 = (_17 = (_16 = axiosError.response) === null || _16 === void 0 ? void 0 : _16.data) === null || _17 === void 0 ? void 0 : _17.collision) !== null && _18 !== void 0 ? _18 : false,
            };
        }
        return {
            success: false,
            errorMessageCode: 'error.update.failed',
        };
    }
});
